import type { Node } from "prosemirror-model";
import type { NodeView } from "prosemirror-view";

export const FORMULA_ERROR_COLOR = "#E84121"; // Red

export class FormulaView implements NodeView {
  dom: HTMLSpanElement;

  constructor(node: Node) {
    this.dom = document.createElement("span");
    this.dom.classList.add("formula");
    this.renderMath(node.attrs.formula as string);
  }

  private renderMath(latex: string): void {
    if (!window.katex) {
      this.dom.textContent = latex;
      return;
    }
    window.katex.render(latex, this.dom, {
      throwOnError: false,
      errorColor: FORMULA_ERROR_COLOR,
    });
  }

  update(node: Node): boolean {
    if (node.type.name !== "formula") return false;
    this.renderMath(node.attrs.formula as string);
    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  ignoreMutation(): boolean {
    // KaTeX injects a complex DOM tree (nested spans, SVGs) inside this.dom.
    // Without this, ProseMirror would interpret those mutations as user edits.
    return true;
  }
}

export function formulaNodeView(node: Node): FormulaView {
  return new FormulaView(node);
}
